import React, { useEffect } from 'react';

// Component to suppress common development warnings
const ConsoleSuppressor: React.FC = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      // Store original console methods
      const originalConsoleLog = console.log;
      const originalConsoleWarn = console.warn;
      
      // Override console.log to filter out specific messages
      console.log = (...args: any[]) => {
        const message = args.join(' ');
        
        // Suppress React DevTools message
        if (message.includes('Download the React DevTools')) {
          return;
        }
        
        // Call original console.log for other messages
        originalConsoleLog.apply(console, args);
      };
      
      // Override console.warn to filter out specific warnings
      console.warn = (...args: any[]) => {
        const message = args.join(' ');
        
        // Suppress React DevTools message
        if (message.includes('Download the React DevTools')) {
          return;
        }
        
        // Suppress Swiper loop warnings (as they're expected with low slide count)
        if (message.includes('Swiper Loop Warning') || message.includes('not enough for loop mode')) {
          return;
        }
        
        // Call original console.warn for other messages
        originalConsoleWarn.apply(console, args);
      };
      
      // Cleanup function to restore original console methods
      return () => {
        console.log = originalConsoleLog;
        console.warn = originalConsoleWarn;
      };
    }
  }, []);

  return null;
};

export default ConsoleSuppressor;